<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputAddress" });
import OutputCountry from "../output-country/OutputCountry.svelte";
export let address;
export let mode = "compact";
$: ({
    building,
    countryCode,
    locality,
    postalCode,
    street,
    sublocality
} = address);
</script>

{#if mode === 'compact'}

    <OutputCountry { countryCode } />

{:else}

    <address>

        {#if street !== undefined || building !== undefined }
            { street ?? '' } { building ?? '' }<br />
        {/if}

        {#if postalCode !== undefined || sublocality !== undefined || locality !== undefined }
            { address.locality ?? ''}
            {#if address.sublocality !== undefined} ({ address.sublocality }) {/if}
            { address.postalCode ?? ''}
            <br />
        {/if}

        <svelte:self address = { address } />

    </address>

{/if}

<style>
    address {
        font-style: normal;
    }</style>